<template>
  <div class="card-wise card-wise-dashboard">
    <h4>Gerenciamento de Envio</h4>
    <h6
      :class="[
        'm-b-0',
        'sub-title-wise',
        userData.statusQueue ? 'text-c-green' : 'text-c-red',
      ]"
    >
      Status: {{ userData.statusQueue ? 'Ativo' : 'Parado' }}
    </h6>
    <div class="button-container">
      <div class="button-inner-container">
        <button
          class="btn btn-sm btn-success "
          @click="sendData({ status: true })"
        >
          Iniciar
        </button>
        <button
          class="btn btn-sm  btn-danger"
          @click="sendData({ status: false })"
        >
          Parar
        </button>
        <button class="btn btn-sm  btn-info " @click="showConfirmModal = true">
          Limpar Fila
        </button>
      </div>
    </div>

    <ConfirmModal
      v-if="showConfirmModal"
      :isVisibleConfirm="showConfirmModal"
      @close="showConfirmModal = false"
      :message="'Deseja realmente deletar a fila?'"
      :onConfirm="clearQueue"
    />
  </div>
</template>
<script>
import { changeStatusQueue, clearQueue } from '../../../../../../api/wise';
import { mapActions } from 'vuex';
import ConfirmModal from '../../../components/ConfirmModal.vue';
export default {
  components: { ConfirmModal },
  props: {
    userData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isLoadingConfirm: false,
      showConfirmModal: false,
    };
  },
  methods: {
    ...mapActions(['loadUser', 'loadQueue']),
    async sendData({ status }) {
      const payload = {
        statusQueue: status,
        userId: this.userData._id,
      };

      await changeStatusQueue({
        payload,
      });
      await this.loadUser();
    },

    async clearQueue() {
      const payload = {
        user_id: this.userData._id,
      };

      await clearQueue({
        payload,
      }).then(() => this.loadQueue());
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.button-inner-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 300px;
}

a {
  font-size: 13px;
  color: #37474f;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-outf;
}
.card {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card .card-header.borderless {
  border-bottom: 0 solid transparent;
}

.card .card-header.borderless + .card-block,
.card .card-header.borderless + .card-block-big,
.card .card-header.borderless + .card-block-small {
  padding-top: 0;
}

h4,
h2,
h6,
h3 {
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 16px;
}
h2 {
  font-size: 26px;
  font-weight: bold;
}
h6 {
  font-size: 13px;
}
.page-header {
  margin: 0 50px;
}
.page-header-title {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 400;
  margin-bottom: 30px;
  background: #019ead;
  color: #fff;
}
.page-header-title span {
  font-size: 13px;
}
.sub-title-wise {
  border-bottom: 1px solid rgba(204, 204, 204, 0.35);
  padding-bottom: 10px;
  /* margin-bottom: 20px; */
  font-size: 14px;
  font-weight: 400;
  color: #2c3e50;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-dashboard {
  padding: 40px;
  background-color: white;
  margin: 0;
  flex: 0 0 calc((100% - 40px) / 3);
  max-width: calc((100% - 40px) / 3);
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.card-type {
  padding: 15px 0;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.addFlowWise {
  display: flex;
  justify-content: center;
}
.saveFlowWise {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}

.bg-c-red {
  background: #ff5370;
}
.text-c-red {
  color: #ff5370;
}
.bg-c-green {
  background: #2ed8b6;
}
.text-c-green {
  color: #2ed8b6;
}
.bg-c-yellow {
  background: #ffb64d;
}
.text-c-yellow {
  color: #ffb64d;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-0 {
  margin-bottom: 0;
}
.body {
  padding: 0 40px;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: white;
  margin-right: 40px;
}
.btn-sm {
  padding: 8px 14px;
  line-height: 16px;
  font-size: 11px;
}
.card-wise {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card-wise-dashboard {
  background-color: white;
  margin: 0;
  width: 25rem;
  max-width: 230px;
}
.card-wise-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
